import { useIntl } from "react-intl";
import {
  Modal,
  Box,
  Typography,
  Grid,
  Button,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Card,
  IconButton
} from "@mui/material";
import PageHeader from "../../ui/PageHeader";
import PageForm from "../../ui/PageForm";
import CustomInput from "../../ui/CustomInput";
import { useEffect, useState, useRef } from "react";
import BarcodeIcon from "../../ui/BarcodeIcon";
import axios from "../../../api/axiosClient";
import { useLoading } from "../../../components/LoadingContext";
import { handleError } from "../../../services/serviceBase";
import moment, { max } from "moment";
import ExpandableCustomTable from "../../ui/ExpandableCustomTable";
import SizeAndQty from "../../ui/CreditNote/SizeAndQty";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useSelector, useDispatch } from "react-redux";

const AddModal = (props) => {
  const jdaLocationCode = useSelector((state) => state.actas.jdaLocationCode);
  const navigate = useNavigate();

  const modalStyle = {
    position: "relative",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",

    bgcolor: "white",
    boxShadow: 24,
    width: "95%",
    height: "80%",
    overflow: "auto",
    p: 4,
    borderRadius: "5px",
  };

  const handleClose = () => {
    setFoundInvoices([])
    setRowsToSave([])
    page.current = 0;
    maxPage.current = 0;
    setShouldFilterCollapse(false);
    props.handleCloseModal();
  };

  const { setLoading } = useLoading();
  const intl = useIntl();

  const [shouldFilterCollapse, setShouldFilterCollapse] = useState(false);

  const [model, setModel] = useState("");
  const [part, setPart] = useState("");
  const [color, setColor] = useState("");
  const [fromDate, setFromDate] = useState(null);
  const [sku, setSku] = useState("");
  const [customer, setCustomer] = useState("");
  const [seasonCode, setSeasonCode] = useState("");
  const [seasonYear, setSeasonYear] = useState("");
  const [toDate, setToDate] = useState(null);
  //const [invoiceNumber, setInvoiceNumber] = useState("");
  const invoiceNumber = useRef();
  const [currency, setCurrency] = useState(null);
  const [invoiceMatch, setInvoiceMatch] = useState(jdaLocationCode == null);
  const [currencies, setCurrencies] = useState([]);
  const [columns, setColumns] = useState([]);
  const [foundInvoices, setFoundInvoices] = useState([]);
  const [rowsToSave, setRowsToSave] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [useTotalQuantity, setUseTotalQuantity] = useState(false);
  const [defaultQty, setDefaultQty] = useState(false);

  const page = useRef(0);
  const maxPage = useRef(0);
  const rowsForPage = 5;
  
  const getCurrencies = () => {
    axios
      .get("/creditnotereturnfiles/currencies")
      .then((response) => {
        setLoading(false);
        var currenciesItems = [];
        if (response.data !== undefined) {
          response.data.map((x) => {
            currenciesItems.push({
              value: x.idCurrency,
              text: `${x.currencyCode}` + " - " + `${x.currencyDescription}`,
            });
          });
        }
        setCurrencies(currenciesItems);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  useEffect(() => {
    if (currencies.length == 0) {
      getCurrencies();
    }
  }, [currencies]);

  useEffect(() => {
    if (foundInvoices.length > 0) {
      getColumns();
    }
  }, [foundInvoices]);

  const handleSearchClick = () => {
    setShouldFilterCollapse(false);

    const params = new URLSearchParams([]);
    params.append("styleCode", model);
    params.append("colorCode", color);
    params.append("fabricCode", part);
    if(sku != ""){
      params.append("barcode", sku);
    }
    params.append("seasonYear", seasonYear);
    params.append("seasonCode", seasonCode);
    if (invoiceNumber.current.value !== undefined && invoiceNumber.current.value !== "") {
      params.append("invoiceNumber", invoiceNumber.current.value);
    }
    
    if (currency != null) {
      params.append("idCurrency", currency.value);
    }
    if (fromDate !== undefined && fromDate !== "" && fromDate !== null) {
      var date = fromDate.toISOString().substring(0, 10);
      params.append("dateFrom", date);
    }
    if (toDate !== undefined && toDate !== "" && toDate !== null) {
      var date = toDate.toISOString().substring(0, 10);
      params.append("dateTo", date);
    }
    params.append("ignoreShippingCustomer", invoiceMatch);

    params.append("PagingInfo.Skip", `${rowsForPage * (page.current)}`);
    params.append("PagingInfo.Take", `${rowsForPage}`);

    axios
      .get(`/creditnotereturnfiles/${props.idReturnFileHead}/invoices`, {
        params,
      })
      .then((response) => {
        setLoading(false);

        var data = [];
        response.data.paginatedItems.map((x) => {
          var item = x;
          item.tableRowId = x.idInvoiceHeader + "-" + x.invoiceRowNumber;
          data.push(item);
        });

        setFoundInvoices(data);
        setShouldFilterCollapse(true);

        maxPage.current = Math.ceil(response.data.totalCount / rowsForPage);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const getColumns = () => {
    setColumns([
      {
        field: "idInvoiceRow",
        className: "grid-header apeLigthBlueBackground",
        renderHeader: () => intl.formatMessage({ id: "Invoice.Nr" }),
        renderCell: (params) => params.row.invoiceYear + "/" + params.row.invoiceQualifier + "/" + params.row.invoiceNumber + "/" + params.row.invoiceRowNumber
      },
      {
        field: "invoiceDate",
        className: "grid-header apeLigthBlueBackground",
        renderHeader: () => intl.formatMessage({ id: "Invoice.Date" }),
        renderCell: (params) => moment(params.row.invoiceDate).format("YYYY-MM-DD")
      },
      {
        field: "customerInvoice",
        className: "grid-header apeLigthBlueBackground",
        renderHeader: () => intl.formatMessage({ id: "General.Customer" })
      },
      {
        field: "idSku",
        className: "grid-header apeLigthBlueBackground",
        renderHeader: () => intl.formatMessage({ id: "Article.Article" }),
        renderCell: (params) => params.row.styleCode + "-" + params.row.fabricCode + "-" + params.row.colorCode
      },
      {
        field: "skuDescription",
        className: "grid-header apeLigthBlueBackground",
        renderHeader: () => intl.formatMessage({ id: "General.Description" })
      },
      {
        field: "unitPrice",
        className: "grid-header apeLigthBlueBackground",
        renderHeader: () => intl.formatMessage({ id: "General.UnitPrice" })
      },
      {
        field: "currencyCode",
        className: "grid-header apeLigthBlueBackground",
        renderHeader: () => intl.formatMessage({ id: "General.Currency" })
      },
      {
        field: "idInvoiceRow",
        className: "grid-header apeLigthBlueBackground",
        renderHeader: () => intl.formatMessage({ id: "General.QuantityTot" }),
        renderCell: (params) =>
          params.row.sizesAndQuantities
            .map((x) => x.quantity)
            .reduce((acc, curr) => acc + curr, 0)
      },
      {
        field: "financialDiscount",
        className: "grid-header apeLigthBlueBackground",
        renderHeader: () => intl.formatMessage({ id: "General.Discount" }),
        renderCell: (params) => {
          let discount = sumDiscounts(params.row);
          return discount > 0 ? discount + "%" : "";
        },
      },
      {
        field: "unitPrice",
        className: "grid-header apeLigthBlueBackground",
        renderHeader: () => intl.formatMessage({ id: "General.TotalPrice" }),
        renderCell: (params) => {
          let discount = sumDiscounts(params.row);
          let totQty = params.row.sizesAndQuantities
            .map((x) => x.quantity)
            .reduce((acc, curr) => acc + curr, 0);

          let totPrice = params.row.unitPrice * totQty;
          if (discount > 0) {
            let discountTot = (totPrice * discount) / 100;
            totPrice -= discountTot;
          }
          return totPrice;
        },
      },
      {
        field: "customCode",
        className: "grid-header apeLigthBlueBackground",
        renderHeader: () => intl.formatMessage({ id: "RAPreparing.CustomCode" }),
      },
      {
        field: "seasonCode",
        className: "grid-header apeLigthBlueBackground",
        renderHeader: () => intl.formatMessage({ id: "General.Season" }),
        renderCell: (params) => {
          if (params.row.seasonCode != null && params.row.seasonYear != null) {
            return params.row.seasonCode + "/" + params.row.seasonYear;
          }
          return "";
        },
      },
      {
        field: "eventCode",
        className: "grid-header apeLigthBlueBackground",
        renderHeader: () => intl.formatMessage({ id: "General.Event" })
      },
    ]);
  };

  const sumDiscounts = (row) => {
    let discount = 0;
    if (row.financialDiscount !== undefined && row.financialDiscount !== null) {
      discount += row.financialDiscount;
    }
    if (row.customerDiscount !== undefined && row.customerDiscount !== null) {
      discount += row.customerDiscount;
    }
    if (row.goodsDiscount !== undefined && row.goodsDiscount !== null) {
      discount += row.goodsDiscount;
    }

    return discount;
  };

  function ShowQty(row) {
    let distinctArticles = [...new Set(row.sizesAndQuantities.map(x=>x.idArticle))];
    let sizesToShow = [];
    distinctArticles.forEach(element => {
      var item = row.sizesAndQuantities.find((x) => x.idArticle == element);
      let tempQty = null;
      let existingRowToSave = rowsToSave.find((x) => x.IdInvoiceHeader == row.idInvoiceHeader && x.IdArticle == item.idArticle && x.InvoiceRowNumber == item.invoiceRowNumber);
      if(existingRowToSave != undefined){
        tempQty = existingRowToSave.RequestedQty;
      }
      sizesToShow.push({
        sizeDescription: item.sizeDescription,
        quantity: item.quantity,
        idArticle: element,
        idInvoiceRowList: item.idInvoiceRowList,
        invoiceRowNumber: item.invoiceRowNumber,
        idInvoiceHeader: row.idInvoiceHeader,
        tempQty: tempQty
      })
    });

    return (
      <>
        {sizesToShow.map((invoiceSize, index) => {
          let isSelected =
            selectedRows
              .some(x => x.idInvoiceHeader == invoiceSize.idInvoiceHeader && x.invoiceRowNumber == invoiceSize.invoiceRowNumber);
          return (
            <Grid item key={index}>
              <SizeAndQty
                sizeDescription={invoiceSize.sizeDescription}
                renderedQty={invoiceSize.quantity}
                maxQty={invoiceSize.quantity}
                isInEdit={true}
                valueChangedFunction={(e) => handleChangeQtyInputOfRow(e, invoiceSize)}
                setTotalQuantity={useTotalQuantity}
                resetSetTotalQuantity={(e) => handleResetUseTotQty(e)}
                isSelected={isSelected}
                defaultQty={defaultQty}
                key={`${invoiceSize.idInvoiceHeader}-${invoiceSize.invoiceRowNumber}-${invoiceSize.sizeDescription}`}
                tempQty={invoiceSize.tempQty}
              />
            </Grid>
          );
        })}
      </>
    );
  }

  const handleChangeSelectedRowsOfTable = (value) => {
    if(!value || value.length <= 0) {
      return;
    }

    var itemList = selectedRows;
    value.forEach(x => {
      let tokens = x.split('-');
      
      let alreadySelected = selectedRows.find((x) => x.idInvoiceHeader == tokens[0] && x.invoiceRowNumber == tokens[1]) != undefined;
      if(alreadySelected){
        return;
      }

      foundInvoices
        .find((x) => x.idInvoiceHeader == tokens[0] && x.invoiceRowNumber == tokens[1])
        .sizesAndQuantities
        .forEach(x => {
          x.idInvoiceHeader = Number(tokens[0])
          itemList.push(x);
        });
    });
    
    setSelectedRows(itemList);
  };

  const handleChangeQtyInputOfRow = (e, size) => {
    let itemsToSave = rowsToSave;
    let find = itemsToSave.find((x) => x.IdArticle == size.idArticle && x.InvoiceRowNumber == size.invoiceRowNumber && x.IdInvoiceHeader == size.idInvoiceHeader);
    if(find != undefined){
      find.RequestedQty = Number(e)
    }
    else {
      itemsToSave.push({
        IdArticle: size.idArticle,
        IdInvoiceRowList: size.idInvoiceRowList,
        RequestedQty: Number(e),
        InvoiceRowNumber: size.invoiceRowNumber,
        IdInvoiceHeader: size.idInvoiceHeader
      })
    }
    setRowsToSave([...itemsToSave])
  };

  const handleResetUseTotQty = () => {
    setUseTotalQuantity(false);
  };

  const handleSaveAddedRows = (e) => {
    e.preventDefault();
    if (selectedRows.length == 0) {
      toast.error(
        intl.formatMessage({ id: "RAPreparing.Add.ErrorSelectRows" })
      );
      return;
    }
    let toSave = [];
    rowsToSave.forEach(element => {
      let find = selectedRows.find((x) => x.idInvoiceHeader == element.IdInvoiceHeader && x.invoiceRowNumber == element.InvoiceRowNumber);
      if(find){
        toSave.push(element)
      }
    });

    let obj = {IgnoreShippingCustomer: invoiceMatch, RequestedQtyByArticle: toSave}

    var url = `/creditnotereturnfiles/${props.idReturnFileHead}/add`;
    axios
      .post(url, obj)
      .then((response) => {
        setLoading(false);
        toast.success("Saved!");
        handleClose();
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const handleInsertTotalQty = (e) => {
    if (selectedRows.length == 0) {
      toast.error(intl.formatMessage({ id: "RAPreparing.Add.SelectRows" }));
      return;
    }
    setUseTotalQuantity(true);
  };

  const handleNextPage = () => {
    if (page.current < maxPage.current) {
      page.current = page.current + 1;
      handleSearchClick();
    }
  };

  const handlePreviousPage = () => {
    if (page.current > 0) {
      page.current = page.current - 1;
      handleSearchClick();
    }
  };

  return (
    <Modal open={props.openModal} onClose={handleClose}>
      <Box sx={modalStyle}>
        <PageHeader title={props.modalHeaderText} />
        <PageForm
          //adjustHeightFunc={handletrasitionEnd}
          shouldCollapse={shouldFilterCollapse}
          form={
            <form>
              <Grid container spacing={2}>
                <Grid item md={4} xs={12}>
                  <CustomInput
                    labelText={intl.formatMessage({ id: "General.Model" })}
                    type="text"
                    value={model}
                    setValue={setModel}
                    textCol={3}
                    inputCol={9}
                  />
                  <CustomInput
                    labelText={intl.formatMessage({ id: "General.Part" })}
                    type="text"
                    value={part}
                    setValue={setPart}
                    textCol={3}
                    inputCol={9}
                  />
                  <CustomInput
                    labelText={intl.formatMessage({ id: "General.Color" })}
                    type="text"
                    value={color}
                    setValue={setColor}
                    textCol={3}
                    inputCol={9}
                  />
                  <CustomInput
                    labelText={intl.formatMessage({ id: "RASearch.FromDate" })}
                    type="date"
                    valueRef={fromDate}
                    setValue={setFromDate}
                    textCol={3}
                    inputCol={9}
                  />
                </Grid>
                <Grid item md={4} xs={12}>
                  <CustomInput
                    labelText={intl.formatMessage({ id: "General.Sku" })}
                    type="text"
                    value={sku}
                    setValue={setSku}
                    textCol={3}
                    inputCol={9}
                    iconComponent={BarcodeIcon}
                  />
                  <CustomInput
                    labelText={intl.formatMessage({ id: "General.Customer" })}
                    type="text"
                    value={customer}
                    setValue={setCustomer}
                    textCol={3}
                    inputCol={9}
                  />
                  <Grid container>
                    <Grid item md={8} xs={12}>
                      <CustomInput
                        labelText={intl.formatMessage({ id: "General.Season" })}
                        type="text"
                        value={seasonYear}
                        setValue={setSeasonYear}
                        textCol={4.5}
                        inputCol={7.5}
                      />
                    </Grid>
                    <span style={{ fontSize: "25px", color: "grey" }}>/</span>
                    <Grid item md={3.8} xs={12}>
                      <CustomInput
                        type="number"
                        value={seasonCode}
                        setValue={setSeasonCode}
                        textCol={0}
                        inputCol={12}
                      />
                    </Grid>
                  </Grid>

                  <CustomInput
                    labelText={intl.formatMessage({ id: "RASearch.ToDate" })}
                    type="date"
                    valueRef={toDate}
                    setValue={setToDate}
                    textCol={3}
                    inputCol={9}
                  />
                </Grid>
                <Grid item md={4} xs={12}>
                  {/* <CustomInput
                    labelText={intl.formatMessage({
                      id: "RADetails.InvoiceNr",
                    })}
                    type="number"
                    value={invoiceNumber}
                    setValue={setInvoiceNumber}
                    textCol={3}
                    inputCol={9}
                  /> */}
                  <CustomInput
                    labelText={intl.formatMessage({ id: "RADetails.InvoiceNr" })}
                    type="text"
                    valueRef={invoiceNumber}
                    textCol={3}
                    inputCol={9}
                  />
                  <CustomInput
                    labelText={intl.formatMessage({ id: "General.Currency" })}
                    type="autocomplete"
                    value={currency}
                    setValue={setCurrency}
                    selectItems={currencies}
                    textCol={3}
                    inputCol={9}
                  />
                  <FormGroup sx={{ ml: 1 }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={invoiceMatch}
                          onChange={(e) => {
                            setInvoiceMatch(e.target.checked);
                          }}
                        />
                      }
                      label={intl.formatMessage({
                        id: "RAPreparing.Add.InvoiceMatchLegalEntity",
                      })}
                    />
                  </FormGroup>
                  <Box display="flex" justifyContent="flex-end">
                    <Button
                      variant="contained"
                      className="apeLigthBlueBackground"
                      onClick={handleSearchClick}
                    >
                      {intl.formatMessage({ id: "General.Search" })}
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </form>
          }
        />
        <Card
          sx={{ mt: 1 }}
          className="apeDarkGreyBackground"
          id="actionsBottom"
        >
          <Grid container>
            <Grid item md={1} sm={12}>
              <Grid item>
                <IconButton
                  sx={{ color: "white" }}
                  onClick={handlePreviousPage}
                >
                  <ArrowBackIosIcon />
                </IconButton>
                <IconButton
                  sx={{ color: "white" }}
                  onClick={handleNextPage}
                  disabled={maxPage.current - page.current == 1}
                >
                  <ArrowForwardIosIcon />
                </IconButton>
              </Grid>
            </Grid>
            <Grid item md={9} sm={12} style={{display: "flex"}}>
              <Typography sx={{color: "white", pt: 1}}>{intl.formatMessage({ id: "General.Page" })} {page.current + 1} {intl.formatMessage({ id: "General.Of" })} {maxPage.current}</Typography>
            </Grid>
            <Grid item md={2} sm={12}>
              <Button
                sx={{ color: "white" }}
                onClick={handleInsertTotalQty}
                disableRipple={true}
              >
                [{intl.formatMessage({ id: "RAPreparing.Add.InsertTotalQty" })}]{" "}
              </Button>
              <Button
                sx={{ color: "white" }}
                onClick={handleSaveAddedRows}
                disableRipple={true}
              >
                [{intl.formatMessage({ id: "General.Save" })}]{" "}
              </Button>
            </Grid>            
            {/* <div style={{ margin: "auto" }}></div> */}
          </Grid>
        </Card>
        <Box sx={{ maxHeight: "62vh", overflow: "auto", mt: 1 }}>
          {foundInvoices.length > 0 && columns.length > 0 ? (
            <ExpandableCustomTable
              id={"tableRowId"}
              columns={columns}
              rows={foundInvoices}
              isEnabledSelection={true}
              defaultHeaderClass="apeLigthBlueBackground"
              OnChangeSelectedRows={handleChangeSelectedRowsOfTable}
              alwaysExpanded={true}
              name={"addTable"}
              renderExpanded={ShowQty}
              size={"small"}
            />
          ) : (
            ""
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default AddModal;
